import { render } from "./SgbvRegister.vue?vue&type=template&id=471b916c&scoped=true"
import script from "./SgbvRegister.vue?vue&type=script&lang=js"
export * from "./SgbvRegister.vue?vue&type=script&lang=js"

import "./SgbvRegister.vue?vue&type=style&index=0&id=471b916c&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471b916c"]])

export default __exports__